export const MainTitle = 'Sentinel One | Appsec - Sone.cz';
